import { AiMessageBubble } from "./ai-message-bubble";
import { UserMessageBubble } from "./user-message-bubble";
import { TypingIndicator } from "./typing-indicator";
import type { ChatMessage } from "@/services/chat-service";

interface ChatMessageListProps {
  messages: ChatMessage[];
  isLoading?: boolean;
}

export function ChatMessageList({ messages, isLoading }: ChatMessageListProps) {
  return (
    <div
      role="log"
      aria-label="상담 대화"
      aria-live="polite"
      aria-busy={isLoading}
      className="flex flex-col gap-3.5 py-2"
    >
      {messages.map((msg) =>
        msg.role === "assistant" ? (
          <AiMessageBubble key={msg.id} content={msg.content} />
        ) : (
          <UserMessageBubble key={msg.id} content={msg.content} />
        ),
      )}
      {isLoading && <TypingIndicator />}
    </div>
  );
}
